// extracted by mini-css-extract-plugin
export default {"root":"Title_root__QDb0P","heading":"Title_heading__Xw7sg","left":"Title_left__oNexy","right":"Title_right__uUwXi"};